export default "__VITE_ASSET__KiGY739o__"